import { t } from '~/i18n';

export type AlertActivityChartFilter =
  | 'pastHour'
  | 'pastDay'
  | 'past7days'
  | 'past2weeks'
  | 'pastMonth';

export const alertActivityFilters: {
  value: string;
  label: string;
}[] = [
  {
    value: 'pastHour',
    label: t('dashboard.alertActivity.filters.pasthour'),
  },
  {
    value: 'pastDay',
    label: t('dashboard.alertActivity.filters.pastday'),
  },
  {
    value: 'past7days',
    label: t('dashboard.alertActivity.filters.past7days'),
  },
  {
    value: 'past2weeks' as AlertActivityChartFilter,
    label: t('dashboard.alertActivity.filters.past2weeks'),
  },
  {
    value: 'pastMonth' as AlertActivityChartFilter,
    label: t('dashboard.alertActivity.filters.pastmonth'),
  },
].filter((v) => !!v);
